import React, { FC } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalClose,
  Box,
  Text,
  ButtonAppearance,
  Spinner,
} from '@bechtel/gds';
import { DrawerFooterButtonStyled } from '@bechtel/client-common';
import { Trans, t } from '@lingui/macro';
import { Caddy } from '@bechtel/types';
import { map } from 'lodash';

interface RetrunCaddyConfirmProps {
  caddies: Caddy[];
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ReturnCaddyConfirm: FC<RetrunCaddyConfirmProps> = ({ caddies, loading, onCancel, onConfirm }) => {
  return (
    <Modal visible={true} style={{ width: '552px', height: '275px' }}>
      <ModalHeader title={caddies.length > 1 ? t`Return Caddies` : t`Return Caddy`}>
        <ModalClose onClick={onCancel}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box px={{ sm: '500' }} pt={{ sm: '600' }} flexDirection={{ sm: 'column' }}>
          <Box pb={{ sm: '400' }}>
            <Text size="500" family="graphik" color="grey.1000">
              {caddies.length > 1
                ? t`Are you sre you want to return these caddies.`
                : t`Are you sre you want to return this caddy.`}
            </Text>
          </Box>
          <Box pb={{ sm: '400' }}>
            <Text size="500" family="graphik" weight="600" color="grey.1000">
              (
              {map(caddies, (caddy: Caddy, idx: number) => {
                if (idx < caddies.length - 1) {
                  return ` ${caddy.label}, `;
                } else {
                  return ` ${caddy.label} `;
                }
              })}
              )
            </Text>
          </Box>
          <Box pb={{ sm: '600' }}>
            <Text size="500" family="graphik" color="grey.1000">
              <Trans>This action can not be undone.</Trans>
            </Text>
          </Box>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <DrawerFooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={onCancel}>
              <Trans>CANCEL</Trans>
            </DrawerFooterButtonStyled>
          </Box>
          <Box>
            <DrawerFooterButtonStyled appearance={ButtonAppearance.SECONDARY} onClick={onConfirm}>
              {loading ? <Spinner /> : t`YES, PROCEED`}
            </DrawerFooterButtonStyled>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};

export default ReturnCaddyConfirm;
